export const HAIGroupId = "60af3bf5-5662-427b-830d-683a45924351";
export const HAIGroupIdProd = "22968970-ef3b-4886-ad46-dd383caf9746";
export const AthenaGroupId = "0b5b85f8-1032-47ac-9a79-49e5eb1940e4";
export const checkGroupsApi = "https://graph.microsoft.com/v1.0/me/checkMemberGroups";
export const HaiUrl = "/hai/";
export const AthenaUrl = "/athena/";

export const msal = {
  clientId: "6ed7548c-79b5-4343-88a8-da38cc2930bc",
  authority: "https://login.microsoftonline.com/1e355c04-e0a4-42ed-8e2d-7351591f0ef1",
};

export const colors = {
  blackish: "#000000",
  whiteish: "#F8F8F8",
};
